module.exports = __webpack_public_path__ + "img/ic-dash-excel-down.87c10b62.svg";